import { call, takeLatest } from "redux-saga/effects";
import {
  SCHEME_LIST,
  SCHEME_GET,
  SCHEME_CREATE,
  SCHEME_UPDATE,
  SCHEME_PAUSE,
  SCHEME_RESUME,
  SCHEME_ARCHIVE,
  SCHEME_REORDER,
  SCHEME_EVALUATE,
} from "../types";
import {
  schemeListApi,
  schemeGetApi,
  schemeCreateApi,
  schemeUpdateApi,
  schemePauseApi,
  schemeResumeApi,
  schemeArchiveApi,
  schemeReorderApi,
  schemeEvaluateApi,
} from "../apis/scheme-api";

function* runOk(action, apiCall) {
  try {
    const res = yield call(apiCall, action.data);
    if (res.status === 200) {
      yield action.onSuccess && action.onSuccess(res.data);
    } else {
      yield action.onError && action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError && action.onError(error?.response?.data || error);
  }
}

function* listWorker(action) { yield* runOk(action, schemeListApi); }
function* getWorker(action) { yield* runOk(action, schemeGetApi); }
function* createWorker(action) { yield* runOk(action, schemeCreateApi); }
function* updateWorker(action) { yield* runOk(action, schemeUpdateApi); }
function* pauseWorker(action) { yield* runOk(action, schemePauseApi); }
function* resumeWorker(action) { yield* runOk(action, schemeResumeApi); }
function* archiveWorker(action) { yield* runOk(action, schemeArchiveApi); }
function* reorderWorker(action) { yield* runOk(action, schemeReorderApi); }
function* evaluateWorker(action) { yield* runOk(action, schemeEvaluateApi); }

export function* schemeListWatcher() { yield takeLatest(SCHEME_LIST, listWorker); }
export function* schemeGetWatcher() { yield takeLatest(SCHEME_GET, getWorker); }
export function* schemeCreateWatcher() { yield takeLatest(SCHEME_CREATE, createWorker); }
export function* schemeUpdateWatcher() { yield takeLatest(SCHEME_UPDATE, updateWorker); }
export function* schemePauseWatcher() { yield takeLatest(SCHEME_PAUSE, pauseWorker); }
export function* schemeResumeWatcher() { yield takeLatest(SCHEME_RESUME, resumeWorker); }
export function* schemeArchiveWatcher() { yield takeLatest(SCHEME_ARCHIVE, archiveWorker); }
export function* schemeReorderWatcher() { yield takeLatest(SCHEME_REORDER, reorderWorker); }
export function* schemeEvaluateWatcher() { yield takeLatest(SCHEME_EVALUATE, evaluateWorker); }
